<div class="tb-container flex-column flex-fill">
  <ag-grid-angular style="height: 100%;" class="ag-theme-balham" [gridOptions]="capitalByWellGridOptions" [context]="{ parentBuildId: ParentBuildId() }"
    [defaultExcelExportParams]="capitalByWellGridOptions.defaultExcelExportParams">
  </ag-grid-angular>
</div>